// extracted by mini-css-extract-plugin
export default {"errorIcon":"style_errorIcon__lYIyb"};